import React, { Component } from 'react';
import PropTypes from 'prop-types';

import poketypes from 'utils/poketypes';
import typeEff from 'utils/typeEff';

import TypeBadge from 'components/TypeBadge';

class TypeTable extends Component {
  render() {
    return (
      <div className="TypeTable  g:12 ts:tiny c:pewter">
        {Object.keys(poketypes).map((type) => {
          const effectiveness = typeEff.calc(this.props.type, type);
          const multiple = typeEff.multiply(effectiveness);

          var color = '';
          switch(effectiveness) {
            case '-2':
              color = 'c:black fw:b';
              break;
            case '-1':
              color = 'c:black o:75';
              break;
            case '1':
              color = 'c:cinnibar o:75';
              break;
            case '2':
              color = 'c:cinnibar fw:b';
              break;
            default:
              color = 'c:pewter';
          }

          return (
            <div className="ta:c  gcol:4 m(gcol:2) p:xs p-x:s" key={type}>
              <TypeBadge type={type} />
              <div className={color}>{multiple}</div>
            </div>
          )
        })}
      </div>
    );
  }
}

export default TypeTable;



// WEBPACK FOOTER //
// ./src/components/TypeTable.js